@if (isVisible) {
    <div id="popup" class="popup">
        <div id="popup-content">
            <span class="close-icon" aria-hidden="true" (click)="close()">&times;</span>
            <div class="row w-100 pl-3 pb-3 text-center">
                <div class="bold-text align-content-center w-100 pb-2 nudge-right blue-color">Ajouter une note</div>
                <div class="col-12 ml-2">
                    <div>
                        @if (ConstsHelper.phoneNumberPattern.test(result.oid)) {
                            <div>
                                <span class="float-left"><strong>Numéro de téléphone: </strong>{{ result.oid }}</span>
                            </div>
                        }
                        @if (result.category == 'bill') {
                            <div>
                                <span class="float-left"><strong>Numéro de facture: </strong>{{ result.oid }}</span>
                            </div>
                        }
                        <br><br>
                        <span class="float-left"><strong>Votre note* </strong></span>
                        <textarea class="form-control w-100" rows="20" (change)="checkNoteEmpty()" [(ngModel)]="note"
                                  required></textarea>
                        @if (displayMessageError) {
                            <small class="form-text error-message">Ce champ est obligatoire.</small>
                        }
                    </div>
                    <button type="button" class="cta_btn level_2" (click)="submit()">Valider<span></span></button>
                </div>
            </div>
        </div>
    </div>
}
